import { B2BDealType, B2CDealType, CostDealType } from "@/app/constants";
import { IPricing } from "@/app/domain";

import { CalculationStrategy, PriceResult } from "../base/calculation.strategy";
import { ReactiveComponent } from "../../entities/base-component";

export class InstallationTotalWithOverchargeCalculationStrategy extends CalculationStrategy {
    calculate(component: ReactiveComponent, [overChargeSum, priceWithDiscount, isOverchargeSelected]): PriceResult {
        if (!overChargeSum || !priceWithDiscount) {
            return this.getDefaultResult();
        }

        return {
            price: this.calculatePriceWithOvercharge(
                overChargeSum, priceWithDiscount, isOverchargeSelected,
                CostDealType,
            ),
            priceB2C: this.calculatePriceWithOvercharge(
                overChargeSum, priceWithDiscount, isOverchargeSelected,
                B2CDealType,
            ),
            priceB2B: this.calculatePriceWithOvercharge(
                overChargeSum, priceWithDiscount, isOverchargeSelected,
                B2BDealType,
            ),
        };
    }

    private calculatePriceWithOvercharge(
        overChargeSum: number,
        priceWithDiscount: IPricing,
        isOverchargeSelected: boolean,
        dealType: string,
    ) {
        if (isOverchargeSelected) {
            const sum = priceWithDiscount.getSystemPrice(dealType).getValue() + overChargeSum;

            return sum
        }
        return priceWithDiscount.getSystemPrice(dealType).getValue();
    }
}
